import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from './../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';
import { mapParamsBySchema } from '../../../../util';
import { SUB_BASIC_02_Schema } from './SUB_BASIC_02_Schema';

/**
 * 도급사업관리 적격수급인 평가서(SUB_BASIC_02) 관련 React Query 훅 모음
 * - 기본 조회(useQuery): useSearch1
 * - Mutation 조회(useSearchMutation): useSearch2, useSearch3
 *
 * 만약 MUTATION 훅에서 공통 응답 처리 외에 추가 성공 콜백이 필요하면
 * successOptions 파라미터로 onSuccess 콜백 함수를 넘겨줄 수 있다.
 */

// 적격수급인 평가서 목록 조회
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(SUB_BASIC_02_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['SubcontractorManagement', 'getSubBasicMst02R1', params],
    queryFn: () =>
      apiRequest(
        'post',
        Global.urls.SubcontractorManagement.getSubBasicMst02R1,
        params
      ),
    enabled: true, // 자동 실행
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

// 적격수급인 평가서 상세 조회 (인쇄용)
export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const encryptedParams = mapParamsBySchema(
      SUB_BASIC_02_Schema.mapper.search2,
      context
    );

    return apiRequest(
      'post',
      Global.urls.SubcontractorManagement.getSubBasicMst01R2,
      encryptedParams
    );
  }, successOptions);
};
